/**
 * State
 * @type {Object}
 */
const state = {
    data: {
        password: null,
        password_confirmation: null,
        token: null
    }
}

/**
 * Getters
 * @type {Object}
 */
const getters = {
    params(state) {
        return state.data;
    }
}

/**
 * Actions
 * @type {Object}
 */
const actions = {
    password({commit}, {password, password_confirmation, accepted_terms, token}) {
        commit('set', {password, password_confirmation, accepted_terms, token});
    },

    send({commit, getters}) {
        return new Promise( (resolve, reject) => {
            this.$xhr.post('/api/auth/activate/', getters.params).then( ({result}) => {
                resolve(result);
            }).catch(reject);
        });
    }
}

/**
 * Mutations
 * @type {Object}
 */
const mutations = {
    set(state, {password, password_confirmation, accepted_terms, token}) {
        state.data.password = password;
        state.data.token = token;
        state.data.password_confirmation = password_confirmation;
        state.data.accepted_terms = accepted_terms;
    }
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
